<form [formGroup]="billingAddressForm" (yatSubmit)="submitForm($event)">
  <div class="row">
    <div class="col-12" [ngClass]="{ 'order-2': businessModel === 'B2C' }">
      <div class="form-group tooltip-bottom">
        <label for="organization-name">
          {{ 'checkout.billingInformation.billingAddressForm.companyName.label' | transloco }}
        </label>
        <yat-tooltip-info-icon
          [ngClass]="{
            hidden:
              billingAddressForm.controls.organizationName.invalid &&
              (billingAddressForm.controls.organizationName.dirty || billingAddressForm.controls.organizationName.touched)
          }"
          iconClass="ml-1"
          tooltipClass="tooltip-xl"
          [tooltipContent]="'checkout.billingInformation.billingAddressForm.companyName.tooltip' | transloco">
        </yat-tooltip-info-icon>
        <input
          type="text"
          class="form-control"
          id="organization-name"
          formControlName="organizationName"
          placeholder=""
          maxlength="50"
          yatInput
          [tabIndex]="businessModel === 'B2C' ? 3 : 0" />
        <div class="invalid-feedback" [ngSwitch]="billingAddressForm.controls.organizationName.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.billingInformation.billingAddressForm.companyName.validators.required' | transloco }}</span>
        </div>
      </div>
    </div>
    <div class="col-6 pr-2">
      <div class="form-group">
        <label for="first-name">{{ 'checkout.billingInformation.billingAddressForm.firstName.label' | transloco }}</label>
        <input
          type="text"
          class="form-control"
          id="first-name"
          formControlName="firstName"
          [placeholder]="'checkout.billingInformation.billingAddressForm.firstName.placeholder' | transloco"
          maxlength="50"
          yatAutoFocus
          yatInput
          [tabIndex]="businessModel === 'B2C' ? 1 : 0" />
        <div class="invalid-feedback" [ngSwitch]="billingAddressForm.controls.firstName.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.billingInformation.billingAddressForm.firstName.validators.required' | transloco }}</span>
        </div>
      </div>
    </div>
    <div class="col-6 pl-2">
      <div class="form-group">
        <label for="last-name">{{ 'checkout.billingInformation.billingAddressForm.lastName.label' | transloco }}</label>
        <input
          type="text"
          class="form-control"
          id="last-name"
          formControlName="lastName"
          [placeholder]="'checkout.billingInformation.billingAddressForm.lastName.placeholder' | transloco"
          maxlength="50"
          yatInput
          [tabIndex]="businessModel === 'B2C' ? 2 : 0" />
        <div class="invalid-feedback" [ngSwitch]="billingAddressForm.controls.lastName.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.billingInformation.billingAddressForm.lastName.validators.required' | transloco }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <label for="address"
          ><transloco id="4dee33ca-e68e-4a0b-9dd1-24b8c152ab7b" key="checkout.billingInformation.billingAddressForm.streetAndHouseNumber.label"> </transloco
        ></label>
        <input type="text" class="form-control" id="address" formControlName="address" placeholder="" maxlength="50" yatInput />
        <div class="invalid-feedback" [ngSwitch]="billingAddressForm.controls.address.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.billingInformation.billingAddressForm.streetAndHouseNumber.validators.required' | transloco }}</span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <label for="address2">{{ 'checkout.billingInformation.billingAddressForm.additionalAddressInfoLabel' | transloco }}</label>
        <label for="address2" class="c-gray optional float-right">{{ 'optional' | commonWording | async }}</label>
        <input type="text" class="form-control" id="address2" formControlName="address2" placeholder="" maxlength="50" yatInput />
      </div>
    </div>
    <div class="col-4 pr-2">
      <div class="form-group">
        <label for="postal-code">{{ 'checkout.billingInformation.billingAddressForm.zipCode.label' | transloco }}</label>
        <input type="text" class="form-control" id="postal-code" formControlName="postalCode" placeholder="" maxlength="20" yatInput />
        <div class="invalid-feedback" [ngSwitch]="billingAddressForm.controls.postalCode.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.billingInformation.billingAddressForm.zipCode.validators.required' | transloco }}</span>
        </div>
      </div>
    </div>
    <div class="col-8 pl-2">
      <div class="form-group">
        <label for="city">{{ 'checkout.billingInformation.billingAddressForm.city.label' | transloco }}</label>
        <input type="text" class="form-control" id="city" formControlName="city" placeholder="" maxlength="50" yatInput />
        <div class="invalid-feedback" [ngSwitch]="billingAddressForm.controls.city.errors | classifyValidationError">
          <span *ngSwitchCase="'required'">{{ 'checkout.billingInformation.billingAddressForm.city.validators.required' | transloco }}</span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group">
        <label for="province">{{ 'checkout.billingInformation.billingAddressForm.stateOrProvinceLabel' | transloco }}</label>
        <label for="province" class="c-gray optional float-right">{{ 'optional' | commonWording | async }}</label>
        <input type="text" class="form-control" id="province" formControlName="province" placeholder="" maxlength="50" yatInput />
      </div>
    </div>
    <div class="col-12">
      <yat-form-group labelFor="country-select" [label]="'checkout.billingInformation.billingAddressForm.country.label' | transloco" [optional]="false">
        <yat-country-select id="country-select" ngDefaultControl [formControl]="billingAddressForm.controls.country" yatInput> </yat-country-select>
      </yat-form-group>
    </div>
    <div class="col-12">
      <div class="form-group tooltip-bottom">
        <label for="billing-email">{{ 'checkout.billingInformation.billingAddressForm.billingEmail.label' | transloco }}</label>
        <label for="billing-email" class="c-gray optional float-right">{{ 'optional' | commonWording | async }}</label>
        <yat-tooltip-info-icon
          [ngClass]="{
            hidden: billingAddressForm.controls.email.invalid && (billingAddressForm.controls.email.dirty || billingAddressForm.controls.email.touched)
          }"
          iconClass="ml-1"
          tooltipClass="tooltip-xl"
          [tooltipContent]="'checkout.billingInformation.billingAddressForm.billingEmail.tooltip' | transloco">
        </yat-tooltip-info-icon>
        <input type="email" class="form-control" id="billing-email" formControlName="email" placeholder="" maxlength="254" yatInput />
        <div class="invalid-feedback" [ngSwitch]="billingAddressForm.controls.email.errors | classifyValidationError">
          <span *ngSwitchCase="'email'">{{ 'checkout.billingInformation.billingAddressForm.billingEmail.validators.email' | transloco }}</span>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="form-group mb-2">
        <label for="vat-id">{{ 'checkout.billingInformation.billingAddressForm.vatIdLabel' | transloco }}</label>
        <label for="vat-id" class="c-gray optional float-right">{{ 'optional' | commonWording | async }}</label>
        <input type="text" class="form-control" id="vat-id" formControlName="vatId" maxlength="50" yatInput />
      </div>
    </div>
  </div>
  <yat-buttons
    [primaryButtonName]="('saveAndContinue' | commonWording | async) ?? ''"
    [secondaryButtonName]="('back' | commonWording | async) ?? ''"
    (secondaryButtonClickMethod)="cancel()"
    [className]="buttonsClassName"
    [matomoEventCategory]="MATOMO_EVENT_CATEGORY_BILLING"
    matomoEventClickPrimaryButtonAction="Submit_NewBillingAddress"
    matomoEventClickSecondaryButtonAction="Cancel_BillingAddressForm">
  </yat-buttons>
</form>
